import React, {useState} from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons"; 
import {Link} from "react-router-dom";
import ListGroup from 'react-bootstrap/ListGroup';
import Rightbar from './Rightbar';
import ImageUploading from 'react-images-uploading';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function Thanks() {
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
setsidebar(!sidebar);
setmainbar(!mainbar);
}
const [date, setDate] = useState(new Date());
const [images, setImages] = React.useState([]);
const maxNumber = 69;

const onChange = (imageList, addUpdateIndex) => {
// data for submit
console.log(imageList, addUpdateIndex);
setImages(imageList);
};
return(
<>

<section className="sec-container" >
<div className='container'>
<div className='portalevent'>
<div className='row'>
<div className={`col-md-12 rightbar-open ${mainbar ? 'open' : ''}`}>
<div className='rightbar' style={{'text-align':'center'}}>

<h1 style={{'text-align':'center'}}>Thank You!</h1>
<p>Your application is now complete and initial payment has been made. Pending approval from Site Administrator.</p>
<p>Photo l.a. will review your application and contact you via email with approval status. In 
some instances, our email may end up in your SPAM or JUNK filters. Be on the lookout in those folders just in case.</p>
</div>
</div>
</div>
</div>
</div>

</section>
</>
)
}